<template>
  <v-container fluid>
    <v-card outlined class="elevation-0 pa-3 mt-2">
      <v-row>
        <v-col style="padding-bottom: 0">
          <b>Configurações gerais da turma</b>
        </v-col>
        <v-col cols="auto" style="padding-bottom: 0">
          <v-btn fab text small dark class="text-center" color="primary" @click="settingsFormShow = true">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="3" style="padding-top: 0">
          <span class="caption">Plano da turma</span>
          <br/>
          {{ loadingSettings ? 'Carregando...' : celebrationSettings.type | celebrationType }}
        </v-col>
        <v-col cols="12" sm="6" md="3" style="padding-top: 0">
          <span class="caption">Cashback</span>
          <br/>
          {{ loadingSettings ? 'Carregando...' : celebrationSettings.cashback | celebrationCashback }} {{ !loadingSettings && celebrationSettings.cashback >= 0 && celebrationSettings.cashbackPartner ? celebrationSettings.cashbackPartner : '' | celebrationCashbackPartner }} {{ !loadingSettings && celebrationSettings.cashback >= 0 && celebrationSettings.cashbackExperience ? '+ 0.5% EXPERIÊNCIA' : '' }}
        </v-col>
        <v-col cols="12" sm="12" md="6" style="padding-top: 0">
          <span class="caption">ID do Asana</span>
          <br/>
          <template v-if="loadingSettings">Carregando...</template>
          <template v-else-if="celebrationSettings.asana">{{ celebrationSettings.asana }}</template>
          <template v-else>-</template>
        </v-col>
        <v-col cols="12" style="padding-top: 0">
          <span class="caption">Detalhe</span>
          <div style="white-space: pre-line">{{ loadingSettings ? 'Carregando...' : celebrationSettings.content || 'Sem informação' }}</div>
        </v-col>
      </v-row>
    </v-card>
    <v-row class="py-5">
      <v-col cols="12" sm="6">
        <quicksearch v-model="quicksearch" :immediate="true"></quicksearch>
      </v-col>
      <v-col cols="12" sm="6" class="text-right">
        <v-btn text class="elevation-0 mb-3" color="primary" @click="addNote()">
          <v-icon left>mdi-plus-circle-outline</v-icon> Adicionar anotação
        </v-btn>
      </v-col>
    </v-row>
    <v-card outlined v-if="errorMessage" class="elevation-0 pa-3">
      {{ errorMessage }}
    </v-card>
    <v-card outlined v-else-if="loading" class="elevation-0 pa-3">
      Carregando...
    </v-card>
    <v-card outlined v-else-if="filteredData.length === 0" class="elevation-0 pa-3">
      Nenhuma anotação para {{ referenceTitle }}
    </v-card>
    <v-card outlined v-else class="elevation-0 px-3">
      <template v-for="(item, index) in filteredData">
        <v-divider v-if="index > 0" :key="'note-divider-' + index" />
        <div class="row py-3" :key="'note-item-' + index">
          <div class="col-auto">
            <v-btn fab text small dark class="text-center" color="primary" @click="editNote(item)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </div>
          <div class="col">
            <b>{{ titleObject[item.titleId] || item.titleId || 'Sem assunto' }}</b> <v-chip class="ml-2" small :color="(item.isActive) ? 'primary' : 'mute'">{{ item.isActive ? 'Ativa' : 'Inativa' }}</v-chip>
            <br>
            <small>Última atualização: {{ item.lastUpdate | moment('DD/MM/YYYY HH:mm') }}</small>
            <br>
            {{ item.note }}
          </div>
        </div>
      </template>
    </v-card>
    <note-dialog-form
      :reference="reference"
      :id="editItemId"
      :item="editItem"
      :titleOptions="titleOptions"
      v-if="formNoteShow"
      @canceled="formNoteCanceled"
      @ok="formNoteOk"
    ></note-dialog-form>
    <settings-dialog-form
      :settings="celebrationSettings"
      :celebrationId="celebrationId"
      v-if="settingsFormShow"
      @canceled="settingsFormShow = false"
      @ok="formSettingsOk"
    ></settings-dialog-form>
  </v-container>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

import Quicksearch from '@/components/Quicksearch'
import NoteDialogForm from '../components/NoteDialogForm'
import SettingsDialogForm from '../components/SettingsDialogForm'

export default {
  name: 'deleteModal',
  components: {
    Quicksearch,
    NoteDialogForm,
    SettingsDialogForm
  },
  props: {
    celebrationId: {
      type: String,
      default: null
    },
    customerId: {
      type: String,
      default: null
    },
    participantId: {
      type: String,
      default: null
    },
    reference: {
      required: true,
      type: String
    }
  },
  data () {
    return {
      loading: false,
      loadingSettings: false,
      quicksearch: '',
      data: [],
      titleOptions: [],
      errorMessage: '',
      formNoteShow: false,
      editItemId: '',
      editItem: {},
      celebrationSettings: {
        type: null,
        asana: null,
        content: null,
        cashback: null,
        cashbackPartner: null,
        cashbackExperience: null
      },
      settingsFormShow: false
    }
  },
  computed: {
    ...mapGetters(['isBackoffice']),
    referenceTitle () {
      switch (this.reference) {
        case 'celebration':
          return 'essa turma'
        case 'participant':
          return 'esse participante'
        default:
          return 'esse cliente'
      }
    },
    titleObject () {
      const titleObject = {}
      for (const key in this.titleOptions) {
        titleObject[this.titleOptions[key].id] = this.titleOptions[key].value
      }
      return titleObject
    },
    filteredData () {
      return this.data.filter(e => e.note.toLowerCase().search(this.quicksearch.toLowerCase()) >= 0)
    }
  },
  filters: {
    celebrationType (type) {
      if (type === 'prospect') return 'PROSPECT'
      if (type === 'plan') return 'PLANO HEPPI'
      if (type === 'payuse') return 'PAY USE (SEM PLANO)'
      return 'INDEFINIDO'
    },
    celebrationCashback (val) {
      if (val === 0) return '0%'
      if (val === 1) return '1%'
      if (val === 1.5) return '1,5%'
      if (val === 2) return '2%'
      if (val === 2.5) return '2,5%'
      if (val === 3) return '3%'
      return 'Sem cashback'
    },
    celebrationCashbackPartner (val) {
      if (val === 'amigo-0.5') return '+ 0,5% AMIGO'
      return ''
    }
  },
  methods: {
    ...mapMutations(['SET_SNACKBAR']),
    addNote () {
      this.editItem = {}
      this.editItemId = ''
      this.formNoteShow = true
      if (this.participantId) this.editItem.participantId = this.participantId
      if (this.celebrationId) this.editItem.celebrationId = this.celebrationId
      if (this.customerId) this.editItem.customerId = this.customerId
    },
    editNote (item) {
      this.editItem = { ...item }
      this.editItemId = item.id
      this.formNoteShow = true
      if (this.participantId) this.editItem.participantId = this.participantId
      if (this.celebrationId) this.editItem.celebrationId = this.celebrationId
      if (this.customerId) this.editItem.customerId = this.customerId
    },
    formNoteCanceled () {
      this.editItem = {}
      this.editItemId = ''
      this.formNoteShow = false
    },
    formNoteOk () {
      this.editItem = {}
      this.editItemId = ''
      this.formNoteShow = false
      this.getData()
    },
    formSettingsOk () {
      this.getSettingsData()
      this.settingsFormShow = false
    },
    getData () {
      let query = null
      this.loading = true
      this.data = []

      if (this.participantId) {
        query = this.$firestore.collection('notes').where('reference', '==', 'participant').where('participantId', '==', this.participantId)
      } else if (this.celebrationId) {
        query = this.$firestore.collection('notes').where('reference', '==', 'celebration').where('celebrationId', '==', this.celebrationId)
      } else if (this.customerId) {
        query = this.$firestore.collection('notes').where('reference', '==', 'customer').where('customerId', '==', this.customerId)
      }

      if (query) {
        query.get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              const item = doc.data()
              item.lastUpdate = item.lastUpdate.toDate()
              item.id = doc.id
              this.data.push(item)
            })
            this.data.sort((a, b) => parseInt(new Date(b.lastUpdate).getTime()) - parseInt(new Date(a.lastUpdate).getTime()))
          })
          .catch(() => {
            this.errorMessage = 'Houve um erro ao processar as notas'
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        this.errorMessage = 'Houve um erro ao processar as notas'
        this.loading = false
      }
    },
    getSettingsData () {
      this.loadingSettings = true
      this.$firestore.collection('settings').doc(this.celebrationId).get()
        .then((snapshot) => {
          const data = snapshot.data()
          this.celebrationSettings.type = (data && data.type) || null
          this.celebrationSettings.asana = (data && data.asana) || null
          this.celebrationSettings.content = (data && data.content) || null
          this.celebrationSettings.cashback = (data && data.cashback >= 0) ? data.cashback : null
          this.celebrationSettings.cashbackPartner = (data && data.cashbackPartner) || null
          this.celebrationSettings.cashbackExperience = (data && data.cashbackExperience) || false
        })
        .catch(() => {
          this.SET_SNACKBAR({ text: 'Não foi possivel trazer as configurações, tente novamente' })
        })
        .finally(() => {
          this.loadingSettings = false
        })
    }
  },
  mounted () {
    this.getData()
    this.getSettingsData()
    this.$firestore.collection('titleTypes').where('reference', '==', this.reference).get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const item = doc.data()
          this.titleOptions.push(item)
        })
        this.titleOptions.sort((a, b) => a.value > b.value ? 1 : (b.value > a.value ? -1 : 0))
      })
  }
}
</script>
